<h1 class="page-title">Email Users</h1>
<section class="widget">
    <div class="widget-body">
        <div class="mt">
            <div class="row">
                <div class="col-md-12">
                    <section class="widget">

                        <form class="form-horizontal" [formGroup]="form" novalidate>

                            <div class="row">
                                <div class="col-6">
                                    <div class="row">
                                        <label for="fromMail" class="ms-1 required-label">From Email</label>
                                        <div class="col-12 form-control-container">
                                            <input [formControl]="fromMail" type="email" class="form-control"
                                                   id="fromMail" formControlName="fromMail">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="row" [class.has-danger]="!agencyId?.valid && agencyId?.touched">
                                        <label for="agencyId" class="ms-1 required-label">Agency</label>
                                        <div class="col-12 form-control-container">
                                            <input class="form-control"
                                                   type="text"
                                                   id="agencyId"
                                                   [formControl]="agencyName"
                                                   formControlName="agencyName"
                                                   placeholder="Select an Agency"
                                                   (click)="showAgencyModal()"
                                                   (keydown)="showAgencyModal()"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 mt-5">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="custom-control-container">
                                                <label class="form-check">
                                                    <input class="form-check-input" type="radio"
                                                           [formControl]="selectAllFundTypes"
                                                           [value]="true" name="selectAllFundTypes">
                                                    <span class="form-check-label">Email All Fund Types</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="custom-control-container">
                                                <label class="form-check">
                                                    <input class="form-check-input" type="radio"
                                                           [formControl]="selectAllFundTypes"
                                                           [value]="false" name="selectAllFundTypes">
                                                    <span class="form-check-label">Choose Specific Fund Type(s) to Email</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <!--Fund Types-->
                                    <div class="row mt-5" [class.hidden]="selectAllFundTypes.value">
                                        <label class="required-label col-12">Fund Type:</label>
                                        <div class="col-4" *ngFor="let pledgeType of allPledgeTypes">
                                            <!--check-box-->
                                            <div class="row"
                                                 [class.has-danger]="!fundTypes?.valid && fundTypes?.touched">
                                                <span class="col-md-8">{{pledgeType.name}}</span>
                                                <div class="col-md-3">
                                                    <label class="form-check">
                                                        <input class="form-check-input"
                                                               ngDefaultControl
                                                               type="checkbox"
                                                               name="allPledgeTypes"
                                                               id="fundTypes"
                                                               [checked]="isChecked(pledgeType)"
                                                               [value]="pledgeType"
                                                               (change)="pledgeTypesChange(pledgeType, $event.target.checked)">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-5">
                                <div class="col-6">
                                    <div class="custom-control-container">
                                        <label class="form-check">
                                            <input class="form-check-input" type="radio"
                                                   [formControl]="includeOptOut" formControlName="includeOptOut"
                                                   [value]="false">
                                            <span class="form-check-label">General Email</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="custom-control-container">
                                        <label class="form-check">
                                            <input class="form-check-input" type="radio"
                                                   [formControl]="includeOptOut" formControlName="includeOptOut"
                                                   [value]="true">
                                            <span class="form-check-label">Urgent: Email All Users</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-5">
                                <div class="col-12">
                                    <label for="subject" class="required-label">Message Subject:</label>
                                    <div class="form-control-container">
                                        <input [formControl]="subject" formControlName="subject" type="text"
                                               class="form-control" id="subject">
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-5">
                                <div class="col-12">
                                    <label for="content" class="required-label">Message Body:</label>
                                    <div class="form-control-container">
                                        <textarea [formControl]="content" formControlName="content" type="text"
                                                  class="form-control" id="content"></textarea>
                                    </div>
                                </div>
                            </div>

                        </form>

                        <div class="row mt-1">
                            <div class="display-flex px-2 pt-2">
                                <button class="btn btn-primary" (click)="submit()">Send Email</button>
                            </div>

                        </div>

                    </section>
                    <agency-box (onAgencySelected)="onAgencySelected($event)"></agency-box>
                </div>
            </div>
        </div>
    </div>
</section>
